import Vue from 'vue';
export default Vue.extend({
    props: {
        isActive: {
            type: Boolean,
            required: true
        },
        isRetry: {
            type: Boolean,
            required: true
        },
        loadingText: {
            type: String,
            default: 'Загрузка'
        }
    },
    name: 'loadWidgetErrorShell'
});
